import { executeRequest, Request, Response } from '@jfs/network'
import { getAPIURL, getPaymentHeader } from '../config'
const responseParser = (response: Response) => {
  const { data } = response
  if (data && data?.status?.status === 'SUCCESS' && data?.secure?.token) {
    return data?.secure?.token
  } else {
    throw { message: data?.status?.status }
  }
}

const resolveApi = (vltId: any, requestParam: any) => {
  const publicUrl = getAPIURL('resolveApi') + vltId

  const request: Request<{}> = {
    apiPath: publicUrl,
    method: 'POST',
    body: requestParam,
    headers: getPaymentHeader(),
  }
  return executeRequest(request)
    .then((data) => {
      console.log('data: ', data)
      return responseParser(data)
    })
    .catch((error) => {
      console.log('error: ', error)
      throw error
    })
}

export const getResolveApiRequest = (initiatingEntityId: any, application: any, entityId: any, userId: any) => {
  return {
    entity: {
      initiatingEntityId,
      application,
      type: 11,
      entityId,
    },
    user: {
      userId,
    },
  }
}

export { resolveApi }
